import React, { forwardRef, useState, useEffect } from "react";
import get from "lodash/get";
import { useDispatch, useSelector } from "react-redux";
import { object, number } from "prop-types";
import {
  format,
  startOfDay,
  endOfDay,
  startOfYear,
  endOfYear,
  startOfWeek,
  endOfWeek,
  isSameISOWeek,
  startOfMonth,
  endOfMonth
} from "date-fns";
import DatePicker from "react-datepicker";


import StorySideBar from "../story-sidebar";
import AuthorDefaultLogo from "../../atoms/author-default-img";
import StoryDate from "../../atoms/story-date";

import "./horoscope.m.css";
import { formatStoryDate } from "../../helper/utils";
import ShareIcon from "../../atoms/icons/share-icon";
import SocialMediaShare from "../../molecules/social-media-share";
import { getAdvancedSearchStories } from "../../helper/api";
import useDevice from "../../helper/custom-hook/useDevice";
import Pisces from "../../atoms/zodiac-icons/pisces";
import Aquarius from "../../atoms/zodiac-icons/aquarius";
import Taurus from "../../atoms/zodiac-icons/taurus";
import Gemini from "../../atoms/zodiac-icons/gemini";
import Cancer from "../../atoms/zodiac-icons/cancer";
import Leo from "../../atoms/zodiac-icons/leo";
import Virgo from "../../atoms/zodiac-icons/virgo";
import Libra from "../../atoms/zodiac-icons/libra";
import Scorpio from "../../atoms/zodiac-icons/scorpio";
import Sagittarius from "../../atoms/zodiac-icons/sagittarius";
import Capricorn from "../../atoms/zodiac-icons/capricorn";
import Aries from "../../atoms/zodiac-icons/aries";
import TaboolaAd from "../../ads/taboola-ad";
// import throttle from "lodash/throttle";

const Horoscopes = [
  {
    icon: <Aries />,
    name: "ಮೇಷ",
    key: "aries-ಮೇಷ"
  },
  {
    icon: <Taurus />,
    name: "ವೃಷಭ",
    key: "taurus-ವೃಷಭ"
  },
  {
    icon: <Gemini />,
    name: "ಮಿಥುನ",
    key: "gemini-ಮಿಥುನ"
  },
  {
    icon: <Cancer />,
    name: "ಕರ್ಕಾಟಕ",
    key: "cancer-ಕರ್ಕಾಟಕ"
  },
  {
    icon: <Leo />,
    name: "ಸಿಂಹ",
    key: "leo-ಸಿಂಹ"
  },
  {
    icon: <Virgo />,
    name: "ಕನ್ಯಾ",
    key: "virgo-ಕನ್ಯಾ"
  },
  {
    icon: <Libra />,
    name: "ತುಲಾ",
    key: "libra-ತುಲಾ"
  },
  {
    icon: <Scorpio />,
    name: "ವೃಶ್ಚಿಕ",
    key: "scorpion-ವೃಶ್ಚಿಕ"
  },
  {
    icon: <Sagittarius />,
    name: "ಧನು",
    key: "sagittarius-ಧನು"
  },
  {
    icon: <Capricorn />,
    name: "ಮಕರ",
    key: "capricorn-ಮಕರ"
  },
  {
    icon: <Aquarius />,
    name: "ಕುಂಭ",
    key: "aquarius-ಕುಂಭ"
  },
  {
    icon: <Pisces />,
    name: "ಮೀನ",
    key: "pisces-ಮೀನ"
  }
];

const filterOptions = [
  {
    name: "ದಿನ",
    value: "horoscope-daily"
  },
  {
    name: "ವಾರ",
    value: "horoscope-weekly"
  },
  {
    name: "ಮಾಸ",
    value: "horoscope-monthly"
  },
  {
    name: "ವಾರ್ಷಿಕ",
    value: "horoscope-yearly"
  }
];

const HoroscopeStoryTemplate = ({ story, index }) => {
  const dispatch = useDispatch();

  const hiddenAuthorIds = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "hidden_author_ids"], [])
  );
  const isAdfree = useSelector((state) => get(state, ["qt", "config", "subscriber"]) === "true");
  const hiddenIdsList = Array.isArray(hiddenAuthorIds)
    ? hiddenAuthorIds.map(String)
    : hiddenAuthorIds
      ? [String(hiddenAuthorIds)]
      : [];

  const storyFilter = get(story, ["tags", "0", "slug"], "horoscope-daily");
  const publishedDate = get(story, ["published-at"]);

  const storyPublishedDate = formatStoryDate(publishedDate);
  const defaultStoryDate = publishedDate ? new Date(publishedDate) : new Date();

  const [filterType, setFilterType] = useState(storyFilter);
  const [filterDate, setFilterDate] = useState(defaultStoryDate);

  const [filterOption, setFilterOption] = useState(storyFilter);
  const [toggleSharing, setToggleSharing] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [updateStory, setUpdateStory] = useState(story);

  const author = get(story, ["authors", "0"], {});
  const authorImg = author["avatar-url"] || author["avatar-s3-key"];
  const isAuthorVisible = !hiddenIdsList.includes(String(author.id));

  const preventKeyboardHandler = (e) => (e.target.readOnly = true);
  const isMobile = useDevice();
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(true);

  // useEffect(() => {
  //   const getScroll = () => {
  //     if (typeof window !== "undefined") {
  //       if (window.scrollY > 500) setRenderTaboolaAd(true);
  //     }
  //   };
  //   window.addEventListener("scroll", throttle(getScroll, 300));
  //   return () => window.removeEventListener("scroll", getScroll);
  // }, []);

  useEffect(() => {
    if (filterType === "horoscope-daily") {
      setUpdateStory((prevState) => ({
        ...prevState,
        "hero-image-s3-key": "prajavani-training/2023-04/f0950c6b-058e-42b6-8836-954641724024/daily_horoscope.jpg"
      }));
    } else if (filterType === "horoscope-weekly") {
      setUpdateStory((prevState) => ({
        ...prevState,
        "hero-image-s3-key": "prajavani-training/2023-04/e9853cb1-95e1-4ac6-9214-511aef21a6b8/weekly_horoscope.jpg"
      }));
    } else if (filterType === "horoscope-monthly") {
      setUpdateStory((prevState) => ({
        ...prevState,
        "hero-image-s3-key": "prajavani-training/2023-04/dd084d01-c1e9-4503-81b4-ac5743d28902/monthly_horoscope.jpg"
      }));
    } else if (filterType === "horoscope-yearly") {
      setUpdateStory((prevState) => ({
        ...prevState,
        "hero-image-s3-key": "prajavani-training/2023-04/8b553bb0-8aa2-40c5-b8b1-310916ace88e/yeraly_horoscope.jpg"
      }));
    }
  }, [filterType]);

  const getHoroscopeCard = (item, index) => {
    const text = story?.metadata?.[item.key] || "";
    return (
      <div styleName="horoscope-item">
        <div styleName="icon-wrapper">
          <div styleName="horoscope-icon">{item.icon}</div>
        </div>

        <div styleName="horoscope-text">
          <div styleName="horoscope-name">{item.name}</div>
          <div styleName="horoscope-description">{text}</div>
          <div styleName="horoscope-date-share">
            <StoryDate story={story} />
            <div styleName="share-wrapper">
              <div onClick={() => setToggleSharing(toggleSharing === index ? undefined : index)}>
                <ShareIcon />
              </div>
              <div styleName="share-options">{toggleSharing === index && <SocialMediaShare story={updateStory} />}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const navigateToPage = (url) => global.app.navigateToPage(dispatch, url);

  const getBeforeAndAfterDates = (filterType, dateValue) => {
    switch (filterType) {
      case "horoscope-daily": {
        const startDate = startOfDay(dateValue);
        const endDate = endOfDay(dateValue);
        return [Number(startDate), Number(endDate)];
      }
      case "horoscope-weekly": {
        const startDate = startOfWeek(dateValue);
        const endDate = endOfWeek(dateValue);
        return [Number(startDate), Number(endDate)];
      }
      case "horoscope-monthly": {
        const startDate = startOfMonth(dateValue);
        const endDate = endOfMonth(dateValue);
        return [Number(startDate), Number(endDate)];
      }
      case "horoscope-yearly": {
        const startDate = startOfYear(dateValue);
        const endDate = endOfYear(dateValue);
        return [Number(startDate), Number(endDate)];
      }
    }
  };

  const getFilterStories = (filterType, publishedAfter, publishedBefore) => {
    const params = {
      "tag-name": filterType,
      "published-after": publishedAfter,
      "published-before": publishedBefore
    };

    getAdvancedSearchStories(0, 1, params).then((items) => {
      if (items.length) {
        navigateToPage(`/${items[0].slug}`);
      } else {
        setShowMessage(true);
      }
    });
  };

  const handleDateFilter = (filterType) => (date) => {
    setShowMessage(false);
    setFilterDate(date);
    const values = getBeforeAndAfterDates(filterType, date);
    getFilterStories(filterType, values[0], values[1]);
  };

  const handleTabClick = (type) => {
    setFilterType(type);
    handleDateFilter(type)(new Date());
  };

  const setFilterDropDown = (e) => {
    setFilterOption(e.target.value);
    handleTabClick(e.target.value);
  };

  const DateInput = forwardRef(({ onClick, startDate, endDate }, ref) => {
    return (
      <div styleName="datepicker-weekly" onClick={onClick} ref={ref}>{`${format(startDate, "dd/MM/yyyy")} - ${format(
        endDate,
        "dd/MM/yyyy"
      )}`}</div>
    );
  });

  const renderDateFilter = (filterType) => {
    switch (filterType) {
      case "horoscope-daily":
        return (
          <DatePicker
            selected={filterDate}
            onChange={handleDateFilter("horoscope-daily")}
            className="date-picker"
            dateFormat="dd MMM yyyy"
            maxDate={new Date(new Date().toLocaleDateString())}
            showIcon
            onFocus={preventKeyboardHandler}
          />
        );
      case "horoscope-weekly":
        return (
          <div styleName="weekly-dropdown">
            <DatePicker
              selected={filterDate}
              startDate={startOfWeek(filterDate)}
              maxDate={endOfWeek(new Date())}
              endDate={endOfWeek(filterDate)}
              onChange={handleDateFilter("horoscope-weekly")}
              dayClassName={(date) => {
                isSameISOWeek(date, filterDate) ? "react-datepicker__day--selected" : "";
              }}
              showIcon
              onFocus={preventKeyboardHandler}
              customInput={<DateInput startDate={startOfWeek(filterDate)} endDate={endOfWeek(filterDate)} />}
            />
          </div>
        );
      case "horoscope-monthly":
        return (
          <DatePicker
            selected={filterDate}
            maxDate={endOfMonth(new Date())}
            onChange={handleDateFilter("horoscope-monthly")}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            showIcon
            onFocus={preventKeyboardHandler}
          />
        );
      case "horoscope-yearly":
        return (
          <DatePicker
            selected={filterDate}
            maxDate={endOfYear(new Date())}
            onChange={handleDateFilter("horoscope-yearly")}
            showYearPicker
            dateFormat="yyyy"
            showIcon
            onFocus={preventKeyboardHandler}
          />
        );
    }
  };

  return (
    <div styleName="story-wrapper">
      <div styleName="story-content">
        <div styleName="top-filter-section">
          <div styleName="filters">
            <div
              onClick={() => handleTabClick("horoscope-daily")}
              styleName={`custom-button ${filterType === "horoscope-daily" ? "active" : ""}`}
            >
              ದಿನ
            </div>
            <div
              onClick={() => handleTabClick("horoscope-weekly")}
              styleName={`custom-button ${filterType === "horoscope-weekly" ? "active" : ""}`}
            >
              ವಾರ
            </div>
            <div
              onClick={() => handleTabClick("horoscope-monthly")}
              styleName={`custom-button ${filterType === "horoscope-monthly" ? "active" : ""}`}
            >
              ಮಾಸ
            </div>
            <div
              onClick={() => handleTabClick("horoscope-yearly")}
              styleName={`custom-button ${filterType === "horoscope-yearly" ? "active" : ""}`}
            >
              ವಾರ್ಷಿಕ
            </div>
          </div>
          <select value={filterOption} onChange={setFilterDropDown} styleName="filter-dropdown">
            {filterOptions.map((item) => (
              <option value={item.value}>{item.name}</option>
            ))}
          </select>
          <div styleName="date-wrapper">{renderDateFilter(filterType)}</div>
        </div>

        {showMessage ? (
          <div styleName="no-stories">ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಲಭ್ಯವಿಲ್ಲ</div>
        ) : (
          <>
            <div styleName="title">{story.headline}</div>

            <div styleName="published-date">Published {storyPublishedDate} IST</div>

            {isAuthorVisible && (
              <>
                <div styleName="author-name">{author.name}</div>
                <div styleName="author-block">
                  <div styleName="author-image">
                    {authorImg ? <img src={authorImg} alt="author" /> : <AuthorDefaultLogo width={140} height={140} />}
                  </div>
                  <div styleName="author-text">
                    <span>{author.bio}</span>
                  </div>
                </div>
              </>
            )}

            <div styleName="horoscope-wrapper">{Horoscopes.map((item, index) => getHoroscopeCard(item, index))}</div>
          </>
        )}
        {!isAdfree && renderTaboolaAd ? (
          <TaboolaAd
            container={`taboola-below-article-${story.id}`}
            placement="Below Article Thumbnails"
            mode="thumbnails-e"
          />
        ) : null}
      </div>
      {!isMobile && (
        <div>
          <StorySideBar index={index} story={story} />
        </div>
      )}
    </div>
  );
};

HoroscopeStoryTemplate.propTypes = {
  story: object,
  index: number
};

const HoroscopeStory = (props) => {
  return <HoroscopeStoryTemplate story={props.story} index={props.index} />;
};

HoroscopeStory.propTypes = {
  story: object,
  index: number
};

export default HoroscopeStory;
